import Model from '@/models/Model';

export default class Service extends Model {
    get route () {
        return 'services';
    }

    static get className () {
        return 'Service';
    }

    static get isInStore () {
        return true;
    }
}
